
import Vue from "vue";
import { Component } from "vue-property-decorator";
import IframeCanvas from "@/components/Canvas/IframeCanvas.vue";
import { uiStore } from "@/store/store";

@Component({
  components: {
    IframeCanvas
  }
})
export default class IframeCanvasWrapper extends Vue {
  get isSingularityMode() {
    return uiStore.isSingularityMode;
  }
}
